module.exports = __webpack_public_path__ + "static/img/propTechDevelop.14347b1f.png";